import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import * as types from "../../types/Milestones";

import { createUseStyles } from 'react-jss';

var styles = _defineProperty({
  milestones: {
    listStyle: 'none',
    display: 'flex',
    flexShrink: 0,
    padding: 0
  } },
types.MilestonesVisualTypes.VERTICAL, {
  flexDirection: 'column'
});


var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map